import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom'; 
import './EvaluationPage.css';
import NavbarCapacita from "../../components/NavbarCapacita/NavbarCapacita";
import { validateToken } from "../../services/AuthService"
import Footer from '../../components/footer/Footer';
import Button from "../../components/button/Button";

function EvaluationPage() {
  const token = localStorage.getItem("site")
  const timeoutRef = useRef()
  const [isValidate, setIsValidate] = useState(false)

  const navigate = useNavigate(); 

  const handleIniciarEvaluacion = () => {
    navigate('/typeForm'); 
  };

  useEffect(() => {
    if (token) {
      validateToken(token)
        .then((response) => {
          if (response.status === 200) setIsValidate(true)
        })
        .catch((err) => {
          if (err.response && err.response.status) {
            setIsValidate(false)
            timeoutRef.current = setTimeout(() => {
              navigate("/login")
            }, 4000)
          }
        })
    } else {
      setIsValidate(false)
      navigate("/login")
    }
  }, [token, navigate])

  return (
    <div className="evaluacion-container">
      <NavbarCapacita />
      <div className="evaluacion-content">
        <h1>Evaluación</h1>
        <p>
          A continuación, realizarás una evaluación para medir tus conocimientos adquiridos durante las capacitaciones.
        </p>
        <p>
          Recuerda que es importante haber visto todos los videos de capacitación antes de comenzar.
        </p>
        <Button onClick={handleIniciarEvaluacion}>
          INICIAR EVALUACIÓN
        </Button>
      </div>
      <Footer />
    </div>
  );
}

export default EvaluationPage;